import React from 'react'
import { StyleSheet } from 'react-native'

import CalendarLayout from '../../../assets/calendar-layout.svg'
import { DS } from '../../../design-system'
import { fontFamily } from '../../../theme'

interface CalendarProps {
  month: string | number
  day: string | number
  color?: string
}

const Calendar = ({ month, day, color = '#7b043d' }: CalendarProps) => {
  return (
    <DS.Frame style={styles.container}>
      <CalendarLayout style={styles.calendarLayout} color={color} />
      <DS.Frame style={styles.textContainer}>
        <DS.Text variant="Caption/Bold" style={styles.month}>
          {month}
        </DS.Text>
        <DS.Text variant="Heading 3/Medium" style={styles.day}>
          {day}
        </DS.Text>
      </DS.Frame>
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  container: {
    width: 48,
    height: 60,
    justifyContent: 'center',
    alignItems: 'center'
  },
  calendarLayout: {
    position: 'absolute',
    top: 0,
    left: 0
  },
  textContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  month: {
    position: 'absolute',
    top: 5,
    fontFamily: fontFamily.GTAmericaExtended,
    textAlign: 'center',
    color: 'white',
    fontSize: 12
  },
  day: {
    fontFamily: fontFamily.FeatureDeckMedium,
    position: 'absolute',
    top: 28,
    color: 'black',
    fontSize: 24
  }
})

export default Calendar
